<template>
  <div class="module_one_block">
    <div class="module_one_header_block">
      <div class="module_one_header_container">
        <div class="module_one_header_label">
          Финансовая грамотность и как ее повысить?
        </div>
      </div>
    </div>
    <div class="module_one_main_block">
      <div class="module_one_main_container">
        <div class="module_one_content_container">
          <div class="module_one_plot">
            <a href="#" class="module_one_plot_module">
              О курсе
            </a>
            <a href="#" class="module_one_plot_module">
              Модуль 1
            </a>
            <a href="#" class="module_one_plot_module">
              Модуль 2
            </a>
            <a href="#" class="module_one_plot_module">
              Модуль 3
            </a>
            <a href="#" class="module_one_plot_about">
              Итоговое тестирование
            </a>
          </div>
        </div>
        <div class="module_one_desc">
          <div class="module_two_bad_desc_testing">
            <div class="module_two_desc_test_time">Результат:</div>
            <div class="module_two_desc_test_label">
              Тестирование
            </div>
            <div class="module_two_desc_test_btn">
              <!--              <div class="module_two_desc_test_btn_start">Пройдено</div>-->
              <div class="courses_list_bad_item_date">
                <div class="module_two_desc_test_btn_start">Не пройдено</div>
                <div class="my_courses_list_item_start">Начало: 22.04.22</div>
                <div class="my_courses_list_item_between">|</div>
                <div class="my_courses_list_item_end">Проходной балл: 60%</div>
              </div>
              <div class="module_two_desc_testing_result">53%</div>
            </div>
          </div>
          <div class="final_testing_desc_text_img">
            <div class="final_testing_good_desc_text">
              <div class="final_testing_desc_congrat">Было близко!<br>
                Возможно, получится в следующий раз</div>
              <div class="final_testing_desc_course_title">Повторить попытку</div>
            </div>
            <div class="final_testing_good_desc_img"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FinalTestingBad"
}
</script>

<style scoped>

</style>